export const reportsStudentsListIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view the student list for that school.'
  },
  {
    element: '#teacherFilter',
    intro: 'Select a teacher from the dropdown to view the student list for that teacher.'
  },
  {
    element: '#export-button',
    intro: 'Click here to export the student list for the selected school and teacher.',
  },
  {
    element: '#print-button',
    intro: 'Click here to print the student list for the selected school and teacher.'
  },
  {
    element: '.search-bar',
    intro: 'Click here to search for a specific student name.'
  },
  {
    element: '#report-table-header',
    intro: 'Scroll to view the student list for the selected school and teacher.'
  }
];
